import { VEHICLE_ROUTES } from '../../../config/api-routes';
import instance from '../../../config/instance';
/**
 * Get vehicle list by user ID
 * @param {string} userId - Customer ID
 * @returns {Promise} Vehicle list
 */
export const getVehicleListByUserIdApi = async (userId) => {
    const response = await instance.get(`${VEHICLE_ROUTES.GET_VEHICLE_LIST_BY_USER(userId)}?page=1&limit=1111`);
    return response?.data?.data;
};

export const updateVehicleApi = async ({ id, payload }) => {
    const response = await instance.put(VEHICLE_ROUTES.UPDATE_VEHICLE(id), payload);
    return response?.data;
};

export const deleteVehicleApi = async (id) => {
    const response = await instance.delete(VEHICLE_ROUTES.DELETE_VEHICLE(id));
    return response?.data;
};
